import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ListingOffersAndDeals.css';
import React, { useContext, useState, useMemo, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import FiltersMobileSwitchPanel from './components/FiltersMobileSwitchPanel';
import CurrencySelector from './components/CurrencySelector';
import DropDownMultiselect from './components/DropDownMultiselect';
import OfferAndDealDatePicker from './components/OfferAndDealDatePicker';
import Sorting from './components/Sorting';
import FiltersSelected from './components/FiltersSelected';
import OfferAndDealSearch from './components/OfferAndDealSearch';
import OfferAndDeal from './components/OfferAndDeal';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { getColorByTheme, getPageThemeColors, get, hexToRgb, canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { qsToObject } from '../../utils/querystring';
import getListing from '../../utils/getListing';
import Loader from '../atoms/Loader/Loader';
import { splitter, generateFacetForRequest, addQueryStringMultiple } from '../Listing/index';
import { commonStyles as headerStyle } from '../57_HeaderListingPage/HeaderListingPage';
import { ReactComponent as IconGrid } from '../../resources/icons/layout-grid.svg';
import { ReactComponent as IconList } from '../../resources/icons/layout-list.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isShowRuleIsHide } from '../atoms/BlurCard/BlurCard';
import { checkJssError } from '../../utils/checkJssError';
export var LOCAL_STORAGE_APP_CURRENCY = 'appCurrency';
export var DATE_RANGE_FACET_NAME = 'datesRange';
export var SORT_QUERY_NAME = 'sortBy';
export var TEXT_SEARCH_FACET_NAME = 'title';
export var TAGS_FOR_PREDEFINED_FACET_NAME = 'category';
var getFacetNamesValue = function getFacetNamesValue(filterData) {
  if (filterData && filterData.values) {
    var values = filterData.values.map(function (filter) {
      var item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      var item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      var facet = item1 || item2 || DATE_RANGE_FACET_NAME;
      return facet;
    });
    return values;
  } else {
    return [];
  }
};
export var stateTofacetsObj = function stateTofacetsObj(filterState) {
  return Object.keys(filterState).reduce(function (acc, item) {
    var currentFacetName = filterState[item].facetName;
    var currentValues = filterState[item].value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, currentFacetName, acc[currentFacetName] ? [].concat(_toConsumableArray(acc[currentFacetName]), _toConsumableArray(currentValues)) : currentValues));
  }, {});
};
var getDefaultSortValue = function getDefaultSortValue(location) {
  return canUseDOM ? qsToObject(location.search)[SORT_QUERY_NAME] || '' : '';
};
var getDefaultSearchValue = function getDefaultSearchValue(location) {
  return canUseDOM ? replaceUrlPluses(qsToObject(location.search)[TEXT_SEARCH_FACET_NAME]) || '' : '';
};
var createFilterState = function createFilterState(filtersList, location, history) {
  var qsValues = canUseDOM ? qsToObject(location.search) : {};
  var state = {};
  if (filtersList && filtersList.length) {
    filtersList.forEach(function (filterItem) {
      var fieldName = filterItem.name;
      var fieldTitle = get(filterItem, 'title.jss.value') || filterItem.name;
      var filterTemplate = get(filterItem, 'fieldTypeItem.item.fieldType.value');
      var facetName = get(filterItem, 'fieldNameItem.item.fieldName.value') || DATE_RANGE_FACET_NAME;
      var preselectedTagsValues = get(filterItem, 'preselectedTags.values', []) || [];
      var preselectedTags = [];
      var listOfTags = [];
      if (filterItem.tagsToDisplay && filterItem.tagsToDisplay.values && filterItem.tagsToDisplay.values.length) {
        listOfTags = filterItem.tagsToDisplay.values.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'title.name');
        });
      }
      var preselectedFromQS = qsValues[facetName] ? qsValues[facetName].split(splitter).map(function (value) {
        return replaceUrlPluses(value);
      }).filter(function (value) {
        return listOfTags.includes(value);
      }) : [];
      var preselectedNoDublicates = _toConsumableArray(new Set(_toConsumableArray(preselectedFromQS)));
      if (preselectedTagsValues.length) {
        preselectedTags = preselectedTagsValues.map(function (p) {
          return get(p, 'title.value');
        });
        var selected = {};
        preselectedTags.forEach(function (key) {
          selected[key] = true;
        });
        addQueryStringMultiple(facetName, selected, history);
      }
      var mergedValue = _toConsumableArray(new Set([].concat(_toConsumableArray(preselectedNoDublicates), _toConsumableArray(preselectedTags))));
      var fieldState = {
        title: fieldTitle,
        facetName: facetName,
        filterTemplate: filterTemplate,
        value: mergedValue || []
      };
      if (facetName === DATE_RANGE_FACET_NAME) {
        fieldState.valueReadableString = '';
        fieldState.visible = false;
        fieldState.value = replaceUrlPluses(qsValues[facetName]) || '';
      }
      state[fieldName] = fieldState;
    });
  }
  return state;
};
var ListingOffersAndDealsComponent = function ListingOffersAndDealsComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var location = useLocation();
  var history = useHistory();
  var lang = sitecoreContext && sitecoreContext.language || 'en';
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var dictionary = get(fields, 'data.dictionary');
  var title = get(fields, 'data.listingConfiguration.title');
  var introText = get(fields, 'data.listingConfiguration.introText');
  var secondaryIntroText = get(fields, 'data.listingConfiguration.searchText.jss.value');
  var sortField = get(fields, 'data.listingConfiguration.sorting.sortPrefixes') || [];
  var socialSharing = get(fields, 'data.socialSharing');
  var currencies = get(fields, 'data.listingConfiguration.currencies.currencies', []);
  var countryItems = get(fields, 'data.countries.countryValues') || [];

  /* Filtering vals*/
  var filterData = get(fields, 'data.listingConfiguration.filters', []);
  var typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  var pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value') || 1);
  var mostSearchedValues = getDictionaryItem(dictionary, 'mostSearchedValues') || '';

  /* Generate list of original predefined categories */
  var predefinedFilters = useMemo(function () {
    if (filterData.values && filterData.values.length) {
      var filtersForPredefine = filterData.values.filter(function (jssFilter) {
        return (get(jssFilter, 'fieldNameItem.item.fieldName.value') === TAGS_FOR_PREDEFINED_FACET_NAME && get(jssFilter, 'preselectedTags.values') || []).length;
      }).map(function (predefineItem) {
        return get(predefineItem, 'preselectedTags.values');
      });
      var arrayOfVals = filtersForPredefine.reduce(function (acc, item) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(item.map(function (predefinedValue) {
          return get(predefinedValue, 'title.value');
        })));
      }, []);
      return _toConsumableArray(new Set(_toConsumableArray(arrayOfVals))).map(function (tagValue) {
        return "".concat(TAGS_FOR_PREDEFINED_FACET_NAME, ":").concat(tagValue);
      });
    }
    return [];
  }, [filterData]);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    gridMode = _useState2[0],
    setGridMode = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isVdsite = _useState4[0],
    setIsVdsite = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    currencyIndex = _useState6[0],
    setCurrencyIndex = _useState6[1];
  var _useState7 = useState('AED'),
    _useState8 = _slicedToArray(_useState7, 2),
    currencyName = _useState8[0],
    setCurrencyName = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    filtersMobileItemsVisible = _useState10[0],
    setFiltersMobileItemsVisible = _useState10[1];
  var _useState11 = useState(function () {
      return getDefaultSortValue(location);
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    sortingValue = _useState12[0],
    setSortingValue = _useState12[1];
  var _useState13 = useState(function () {
      return getDefaultSearchValue(location);
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    searchTextValue = _useState14[0],
    setSearchTextValue = _useState14[1];
  var _useState15 = useState(function () {
      return createFilterState(filterData.values.filter(function (settings) {
        return get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME;
      }), location, history);
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    filterState = _useState16[0],
    setFilterState = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    filterFiledOpened = _useState18[0],
    setFilterFiledOpened = _useState18[1];

  /* Filtering states*/
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    hits = _useState20[0],
    setHits = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    page = _useState22[0],
    setpage = _useState22[1];
  var _useState23 = useState(),
    _useState24 = _slicedToArray(_useState23, 2),
    result = _useState24[0],
    setResult = _useState24[1];
  var _useState25 = useState({}),
    _useState26 = _slicedToArray(_useState25, 2),
    facets = _useState26[0],
    setFacets = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    loading = _useState28[0],
    setLoading = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    nbHits = _useState30[0],
    setNbHits = _useState30[1];
  var _useState31 = useState(true),
    _useState32 = _slicedToArray(_useState31, 2),
    setFilters = _useState32[0],
    applySetFilters = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    buttonPressed = _useState34[0],
    setButtonPressed = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    clearAllFilters = _useState36[0],
    setClearAllFilters = _useState36[1];

  /* Dictionary terms */
  var clearAllText = getDictionaryItem(dictionary, 'clearAll') || '';
  var clearText = getDictionaryItem(dictionary, 'clear') || '';
  var viewedAmountText = getDictionaryItem(dictionary, 'viewedAmount') || '';
  var loadMoreText = getDictionaryItem(dictionary, 'loadMore') || '';
  var fromText = getDictionaryItem(dictionary, 'from') || '';
  var offText = getDictionaryItem(dictionary, 'off') || '';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  var moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '';
  var bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  var readMoreText = getDictionaryItem(dictionary, 'readMore') || '';
  var readLessText = getDictionaryItem(dictionary, 'readLess') || '';
  var filtersTitleText = getDictionaryItem(dictionary, 'filtersTitle') || '';
  var autocompletePlaceholderText = getDictionaryItem(dictionary, 'autocompletePlaceholder') || '';
  var resultsTitleText = getDictionaryItem(dictionary, 'resultsTitle') || '';
  var resultsForText = getDictionaryItem(dictionary, 'resultsFor') || '';
  var filtersMobileLabelText = getDictionaryItem(dictionary, 'filtersMobileLabel') || '';
  var showResultsText = getDictionaryItem(dictionary, 'showResults') || '';
  var sortFieldDeskLabelText = getDictionaryItem(dictionary, 'sortFieldDeskLabel') || '';
  var sortFieldMobileLabelText = getDictionaryItem(dictionary, 'Sort') || '';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  var emptySearchText = getDictionaryItem(dictionary, 'emptySearch') || '';
  var ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  useEffect(function () {
    var lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);

  /* Params elements */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  var variables = BackgroundColorHex ? {
    '--listing-deals-background-color': BackgroundColorHex,
    '--listing-deals-background-color-rgb': hexToRgb(BackgroundColorHex, true),
    '--listing-deals-background-active-color': ActiveColorHex,
    '--listing-deals-color': ColorHex
  } : {
    '--listing-deals-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--listing-deals-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    '--listing-deals-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--listing-deals-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var queryParams = canUseDOM ? qsToObject(location.search) : {};
  if (Object.keys(queryParams).length !== 0) {
    for (var key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  var setListingFilter = function setListingFilter() {
    setpage(0);
    setHits([]);
    applySetFilters(true);
  };
  var loadMore = function loadMore() {
    if (canUseDOM) {
      window.onscroll = function () {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    applySetFilters(true);
    setpage(function (prevState) {
      return prevState + 1;
    });
    if (eventsAnalytics['loadMoreAnalytics']) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loadMoreAnalytics'], params));
    }
  };
  var renderResultsText = function renderResultsText() {
    var loadedHits = (page + 1) * pagesize;
    return viewedAmountText.replace('{x}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{y}', String(nbHits));
  };
  var resetAndSubmitFilters = function resetAndSubmitFilters() {
    var newState = _objectSpread({}, filterState);
    Object.keys(newState).forEach(function (filterName) {
      if (newState[filterName].facetName === DATE_RANGE_FACET_NAME) {
        newState[filterName].valueReadableString = '';
        newState[filterName].value = '';
      } else {
        newState[filterName].value = [];
      }
    });
    var finalQSObject = stateTofacetsObj(newState);
    var url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(function (facet) {
      url.searchParams.delete(facet);
    });
    history.replace("".concat(history.location.pathname).concat(url.search).concat(url.hash));
    setFilterState(newState);
    setListingFilter();
  };
  useEffect(function () {
    var algoliaIndexes = sortingValue ? "".concat(get(params, 'SearchIndex'), "_").concat(sortingValue) : get(params, 'SearchIndex');
    var tag = 'tags:';
    if (canUseDOM) {
      var hash = window.location.hash;
      var hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    var types = typeArray.map(function (type) {
      var value = type && type.template.targetItem.value;
      return "type:".concat(value);
    });
    var facetNames = _toConsumableArray(new Set(_toConsumableArray(getFacetNamesValue(filterData))));
    var filters;
    var dateRangeStateName = Object.keys(filterState).find(function (name) {
      return filterState[name].facetName === DATE_RANGE_FACET_NAME;
    });
    if (dateRangeStateName && filterState[dateRangeStateName].value) {
      filters = filterState[dateRangeStateName].value;
    }
    var objOfFacets = stateTofacetsObj(filterState);
    var filterParams = generateFacetForRequest(objOfFacets, filterData, [TAGS_FOR_PREDEFINED_FACET_NAME]);
    var itemFilters = {
      query: searchTextValue,
      filters: filters,
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types), _toConsumableArray(predefinedFilters)].concat(_toConsumableArray(filterParams), [[tag]]),
      hitsPerPage: pagesize,
      page: page
    };
    var listingRequest = function listingRequest() {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters).then(function (response) {
        setFacets(response.facets);
        setResult(response);
        applySetFilters(false);
        setClearAllFilters(false);
        setNbHits(response.nbHits);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            var resultsBlocks = document.querySelectorAll('.deals-grid');
            if (resultsBlocks.length) {
              var lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              var focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                var lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(page === 0 ? response.hits : hits.concat(response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = function () {};
          }
        }, 100);
        setLoading(false);
      });
    };
    if (setFilters) {
      listingRequest();
    }
  }, [setFilters, page, buttonPressed]);
  var togglePanelHandler = function togglePanelHandler(close) {
    setFiltersMobileItemsVisible(close === false ? close : !filtersMobileItemsVisible);
    if (close !== false && document.body.style.overflowY === '') {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = '';
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerSelectWrapper clearfix"
  }, !!currencies.length && /*#__PURE__*/React.createElement("div", {
    className: "selectorFloat"
  }, /*#__PURE__*/React.createElement(CurrencySelector, {
    changeCurrency: setCurrencyIndex,
    changeCurrencyName: setCurrencyName,
    currencyName: currencyName,
    currencies: currencies,
    rtl: rtl,
    themeVariables: variables
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, title && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: title.jss,
    className: "h2 c-title__text textWordBreak"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8"
  }, introText && /*#__PURE__*/React.createElement(Text, {
    className: "p header__content",
    tag: "p",
    field: introText.jss
  }))))))), secondaryIntroText && /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-8"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: secondaryIntroText
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__search"
  }, /*#__PURE__*/React.createElement("div", {
    className: " row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-9 col-xl-10"
  }, /*#__PURE__*/React.createElement(OfferAndDealSearch, {
    rtl: rtl,
    searchValue: searchTextValue,
    setSearchValue: setSearchTextValue,
    placeholder: autocompletePlaceholderText,
    resultsTitle: resultsTitleText,
    resultsForText: resultsForText,
    setListingFilter: setListingFilter,
    mostSearchedValues: mostSearchedValues ? mostSearchedValues.split('|').map(function (term) {
      return term.trim();
    }) : [],
    resultsNumber: nbHits,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))), /*#__PURE__*/React.createElement("h5", {
    className: "filters__header"
  }, filtersTitleText), /*#__PURE__*/React.createElement("div", {
    className: "filters__grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-9 col-xl-10"
  }, /*#__PURE__*/React.createElement(FiltersMobileSwitchPanel, {
    filterState: filterState,
    emptyFilterState: "",
    labelText: filtersMobileLabelText,
    clearAll: clearAllText,
    ctaText: showResultsText,
    togglePanel: togglePanelHandler,
    panelVisible: filtersMobileItemsVisible,
    clearFilter: function clearFilter() {
      togglePanelHandler();
      resetAndSubmitFilters();
    },
    triggerFilterFieldOpen: setFilterFiledOpened
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout-wrapper"
  }, !!(filterData.values && filterData.values.length) && /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout"
  }, filterData.values.filter(function (settings) {
    return get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME;
  }).map(function (singleFilter) {
    var filterTemplate = get(singleFilter, 'fieldTypeItem.item.fieldType.value');
    var facetName = get(singleFilter, 'fieldNameItem.item.fieldName.value');
    if (filterTemplate === 'Dropdown Multi Select') {
      var preselectedTags = get(singleFilter, 'preselectedTags.values', []).map(function (p) {
        return get(p, 'title.value');
      });
      var fieldName = get(singleFilter, 'name');
      var value = filterState[fieldName] === undefined ? preselectedTags : _toConsumableArray(filterState[fieldName].value);
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: fieldName
      }, /*#__PURE__*/React.createElement(DropDownMultiselect, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: function closeMobileOpener() {
          return togglePanelHandler(false);
        },
        setValue: function setValue(newValue) {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, _defineProperty2({}, fieldName, _objectSpread(_objectSpread({}, filterState[fieldName]), newValue))));
          applySetFilters(true);
        },
        value: value,
        preselectedTags: preselectedTags,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        eventsAnalytics: eventsAnalytics,
        params: params,
        clearAllFilters: clearAllFilters
      }));
    }
    if (filterTemplate === 'Date Range') {
      var _fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: _fieldName
      }, /*#__PURE__*/React.createElement(OfferAndDealDatePicker, {
        filter: singleFilter,
        closeMobileOpener: function closeMobileOpener() {
          return togglePanelHandler(false);
        },
        setValue: function setValue(newValue) {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, _defineProperty2({}, _fieldName, _objectSpread(_objectSpread({}, filterState[_fieldName]), newValue))));
        },
        submitedValue: function submitedValue(_submitedValue) {
          _submitedValue && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['selectDatesAnalytics'], params), "".concat(_submitedValue.valueReadableString));
        },
        valueReadableString: filterState[_fieldName].valueReadableString,
        value: filterState[_fieldName].value,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened
      }));
    }
    return null;
  })), /*#__PURE__*/React.createElement("div", {
    className: "filters__mode-selector d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("menu", {
    className: "mode-selector"
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(gridMode ? 'active' : ''),
    onClick: function onClick() {
      if (!gridMode) setGridMode(true);
    }
  }, /*#__PURE__*/React.createElement(IconGrid, null)), /*#__PURE__*/React.createElement("button", {
    className: "".concat(gridMode ? '' : 'active'),
    onClick: function onClick() {
      if (gridMode) setGridMode(false);
    }
  }, /*#__PURE__*/React.createElement(IconList, null)))))), /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-3 col-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__sort"
  }, /*#__PURE__*/React.createElement(Sorting, {
    values: sortField,
    deskLabelText: sortFieldDeskLabelText,
    mobileLabelText: sortFieldMobileLabelText,
    defaultSortValue: '',
    value: sortingValue,
    setSort: function setSort(newValue) {
      setSortingValue(newValue);
    },
    clearText: clearText
    /* ctaText={showResultsText} */,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))))), /*#__PURE__*/React.createElement(FiltersSelected, {
    filterState: filterState,
    setFilter: function setFilter(newValue) {
      setFilterState(_objectSpread(_objectSpread({}, filterState), newValue));
    },
    resetFilters: function resetFilters(newValue) {
      filterData && filterData.values.filter(function (settings) {
        return get(settings, 'fieldNameItem.item.fieldName.value') !== TAGS_FOR_PREDEFINED_FACET_NAME;
      }).map(function (el) {
        var facetName = get(el, 'fieldNameItem.item.fieldName.value');
        var preselectedTags = null;
        if (el.preselectedTags) {
          preselectedTags = get(el, 'preselectedTags.values', []).map(function (tag) {
            return get(tag, 'title.value', get(tag, 'name'));
          });
          if (newValue[el.name]) {
            newValue[el.name].value = preselectedTags;
          } else {
            newValue[el.name] = {
              value: preselectedTags
            };
          }
          var selected = {};
          preselectedTags.forEach(function (key) {
            selected[key] = true;
          });
          addQueryStringMultiple(facetName, selected, history);
        }
      });
      setFilterState(newValue);
      setClearAllFilters(true);
    },
    clearText: clearAllText,
    setListingFilter: setListingFilter,
    facets: facets,
    resetAndSubmitFilters: resetAndSubmitFilters,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
    className: "empty-results",
    dangerouslySetInnerHTML: {
      __html: emptySearchText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row deals-grid ".concat(gridMode ? '' : 'deals-grid--list', " ")
  }, hits.map(function (deal) {
    return /*#__PURE__*/React.createElement("div", {
      key: deal.objectID,
      className: "col-lg-3 ".concat(isShowRuleIsHide(deal) ? 'd-flex' : '')
    }, /*#__PURE__*/React.createElement(OfferAndDeal, {
      textToHighlight: searchTextValue,
      fromText: fromText,
      offText: offText,
      expiresSoonText: expiresSoonText,
      moreInfoText: moreInfoText,
      bookNowText: bookNowText,
      readMoreText: readMoreText,
      readLessText: readLessText,
      termsAndConditionsText: termsAndConditionsText,
      deal: deal,
      rtl: rtl,
      currency: currencyName,
      currencyIndex: currencyIndex,
      gridMode: gridMode,
      socialSharing: socialSharing,
      themeVariables: variables,
      eventsAnalytics: eventsAnalytics,
      params: params,
      ratingTextStars: ratingTextStars,
      ratingTextStar: ratingTextStar,
      countryItems: countryItems
    }));
  })))), loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement("div", {
    className: "deals-bottom-panel"
  }, /*#__PURE__*/React.createElement("p", {
    className: "deals-bottom-panel__amount"
  }, renderResultsText()), /*#__PURE__*/React.createElement("button", {
    onClick: loadMore,
    className: "btn btn-secondary deals-bottom-panel__load-more"
  }, loadMoreText)), /*#__PURE__*/React.createElement("pre", {
    className: "d-none"
  }, /*#__PURE__*/React.createElement("div", null, JSON.stringify(filterState, null, 2)), /*#__PURE__*/React.createElement("div", null, "Sorting: ".concat(sortingValue)), /*#__PURE__*/React.createElement("div", null, "Search submitted text: ".concat(searchTextValue))))))));
};
var ListingOffersAndDeals = function ListingOffersAndDeals(props) {
  return checkJssError(props, ListingOffersAndDealsComponent, props.fields.data.listingConfiguration);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(headerStyle, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "ci72z0l";
var ltrStyles = "lg4cb2d";
var rtlStyles = "r52qsxw";
export default ListingOffersAndDeals;